import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/category", label: "尊享专区" },
  { to: "/vip", label: "会员特权" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <div
        className={`transition-all duration-300 ${
          scrolled
            ? "bg-background-950/95 backdrop-blur-md border-b border-primary-500/20"
            : "bg-transparent border-b border-transparent"
        }`}
      >
        <nav className="mx-auto max-w-7xl px-4 md:px-6" aria-label="主导航">
          <div className="flex h-16 md:h-20 items-center justify-between">
            <Link to="/" className="flex items-center gap-2 group" aria-label="土豪漫画网首页">
              <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-gradient-to-br from-accent-400 to-primary-600 text-foreground-950 text-xl md:text-2xl">
                <i className="ri-vip-diamond-fill"></i>
              </span>
              <span className="font-heading text-xl md:text-2xl font-bold tracking-wide">
                <span className="text-gold-grad">土豪漫画网</span>
              </span>
            </Link>

            <div className="hidden lg:flex items-center gap-8">
              {navLinks.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`relative text-sm font-medium transition-colors hover:text-primary-300 ${
                    isActive(item.to) ? "text-primary-300" : "text-foreground-300"
                  }`}
                >
                  {item.label}
                  {isActive(item.to) && (
                    <span className="absolute -bottom-2 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-400 to-transparent"></span>
                  )}
                </Link>
              ))}
            </div>

            <div className="flex items-center gap-3">
              <Link
                to="/vip"
                className="hidden md:inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-gradient-to-r from-primary-500 to-accent-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition hover:from-primary-400 hover:to-accent-400 cursor-pointer"
              >
                <i className="ri-vip-diamond-fill text-base"></i>
                开通会员
              </Link>
              <button
                onClick={() => setMenuOpen((v) => !v)}
                className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-700 text-foreground-200 cursor-pointer"
                aria-label="打开菜单"
              >
                <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"}></i>
              </button>
            </div>
          </div>
        </nav>

        {menuOpen && (
          <div className="lg:hidden border-t border-background-800 bg-background-950/98">
            <nav className="mx-auto max-w-7xl px-4 py-4 flex flex-col" aria-label="移动端导航">
              {navLinks.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`py-3 text-base font-medium border-b border-background-900 last:border-0 ${
                    isActive(item.to) ? "text-primary-300" : "text-foreground-300"
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <Link
                to="/vip"
                className="mt-3 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-gradient-to-r from-primary-500 to-accent-500 px-5 py-3 text-sm font-semibold text-foreground-950"
              >
                <i className="ri-vip-diamond-fill text-base"></i>
                开通会员
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}

export default Navbar;